var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "acvivity" },
    [
      _c("van-nav-bar", {
        staticClass: "nav-bar",
        attrs: { "right-text": "活动规则", "left-arrow": "" },
        on: { "click-left": _vm.onClickLeft, "click-right": _vm.onClickRight }
      }),
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "img-warper" }, [
          _c("div", { staticClass: "img" }, [
            _c("div", { staticClass: "des" }, [
              _c("div", { staticClass: "money" }, [
                _c("span", { staticClass: "icon" }, [_vm._v("￥")]),
                _c("span", { staticClass: "num" }, [_vm._v(_vm._s(_vm.money))])
              ]),
              _c("div", { staticClass: "tip" }, [_vm._v(_vm._s(_vm.tip))])
            ])
          ])
        ]),
        _c(
          "div",
          { staticClass: "ifo" },
          [
            _c("p", [_vm._v("活动任务")]),
            _vm.pageType === "0"
              ? _vm._l(_vm.list, function(item, index) {
                  return _c("div", { key: index, staticClass: "ifo-item" }, [
                    _c("div", { staticClass: "left" }, [
                      _c("img", {
                        attrs: {
                          src:
                            item.detailType === 1 ? _vm.zhiye : _vm.personIfo,
                          alt: ""
                        }
                      })
                    ]),
                    _c("div", { staticClass: "center" }, [
                      _c("div", { staticClass: "title" }, [
                        _vm._v(
                          _vm._s(
                            item.detailType === 1 ? "执业认证" : "个人资料"
                          )
                        )
                      ]),
                      _c("div", { staticClass: "des" }, [
                        _vm._v(
                          _vm._s(
                            item.detailType === 1
                              ? "上传执业认证且平台审核通过后任务将自动完成。"
                              : "上传执业认证且平台审核通过后任务将自动完成。"
                          )
                        )
                      ])
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "right",
                        class: {
                          "color-grey": item.status !== 2 && item.status
                        },
                        on: {
                          click: function($event) {
                            return _vm.toActivity(item)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.getText(item)))]
                    )
                  ])
                })
              : _c("div", { staticClass: "ifo-item" }, [
                  _vm._m(0),
                  _vm._m(1),
                  _c(
                    "div",
                    {
                      staticClass: "right",
                      class: { "color-grey": !_vm.list[0] },
                      on: { click: _vm.toShare }
                    },
                    [_vm._v("去完成")]
                  )
                ])
          ],
          2
        ),
        _c("div", { staticClass: "notice" }, [_c("notice")], 1)
      ]),
      _c(
        "van-dialog",
        {
          attrs: {
            title: "活动规则",
            showConfirmButton: false,
            closeOnClickOverlay: ""
          },
          model: {
            value: _vm.ruleShow,
            callback: function($$v) {
              _vm.ruleShow = $$v
            },
            expression: "ruleShow"
          }
        },
        [
          _c("div", { staticClass: "content" }, [
            _c("p", [_vm._v("一、活动时间：")]),
            _c("p", { staticStyle: { color: "red" } }, [
              _vm._v("二、2021年8月18日 ~ 2021年10月09日")
            ]),
            _c("p", [_vm._v("三、活动对象：")]),
            _c("p", [
              _vm._v("长律app平台需认证律师的用户，仅限前1000名律师参与")
            ]),
            _c("p", [_vm._v("四、活动内容：")]),
            _c("p", [
              _vm._v(
                "活动期间内，用户通过提交个人资料进行律师认证，平台对认证资料进行审核，审核通过的律师可获得一次新用户奖励金，奖励金将自动发放至平台钱包余额。老用户邀请一位新用户（提交个人认证资料并通过平台审核后），可获得一次奖励金，新用户也可获得一次新用户奖励金，均发放至平台的钱包余额。"
              )
            ]),
            _c("p", [_vm._v("五、活动奖励规则：")]),
            _c("p", [
              _vm._v(
                "1、在活动期间内，每个新用户注册并完成律师认证可获得一次新用户奖励金，老用户邀请新用户注册并通过律师认证仅可获得一次邀新奖励金。"
              )
            ]),
            _c("p", [
              _vm._v("2、平台奖励金可进行提现，也可用于平台内部消费使用。")
            ]),
            _c("p", [
              _vm._v(
                "3、如出现不可抗力（包括但不限于重大灾害事件、活动受政府机关指令需要停止举办或调整的、活动遭受严重网络攻击或因系统故障等）导致活动需要停止或调整的，平台有权终止活动而无需向用户进行赔偿或补偿。"
              )
            ]),
            _c("p", [
              _vm._v(
                "4、如参与本活动的用户存在任何利用系统漏洞、外挂软件、插件、等手段或者工具套取活动奖励、扰乱活动规则、违背活动公平原则的行为我们有权撤销用户参与活动及奖励使用资格，并有权收回用户已经获得的权益。"
              )
            ]),
            _c("p", [
              _vm._v(
                "5、在参与活动过程中，如用户出现认证资料作弊等违法违规行为我们有权撤销用户参与活动及奖励使用资格，并有权收回用户已经获得的权益。"
              )
            ]),
            _c("p", [
              _vm._v(
                "6、活动时间和活动奖励以界面展示为准，平台对本次活动享有最终解释权。"
              )
            ]),
            _c("p", [_vm._v("7、本次活动与苹果公司（Apple Inc.）无关。")]),
            _c("p")
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left" }, [
      _c("img", { attrs: { src: require("./imgs/heart.png"), alt: "" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "center" }, [
      _c("div", { staticClass: "title" }, [_vm._v("邀新得红包")]),
      _c("div", { staticClass: "des" }, [
        _vm._v("邀请一位律师完成认证并审核通过后奖励将自动发放。")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }